import { useBasket } from '../BasketContext/useBasket';
import { calculateBasketSize } from '../utilities/basketHelpers';

export const BasketQuantityBadge = () => {
  const { basket } = useBasket();

  const boughtItemsNumber = calculateBasketSize(basket);
  return <> {boughtItemsNumber > 0 && <span className="numberBadge">{boughtItemsNumber}</span>}</>;
};
